var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import Editicon from "@frameworks/web/assets/images/features/BasicProfile/Editicon.svg";
import NomineeDetailsData from "./NomineeDetailsData";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import { useNavigate } from "react-router-dom";
import di from "@frameworks/web/components/features/BasicProfile/di/servicelocator";
import { accountDetails } from "@mainDi/webDi";
import BasicProfileErrorMsg from "@frameworks/web/components/features/BasicProfile/BasicProfileErrorMsg";
import { navigateSelf } from "@frameworks/web/components/features/ServiceRequest/ServiceRequest";
import { EServiceRequest, SRRedirectionUrl, } from "@frameworks/web/components/features/ServiceRequest/constant";
import Common_Shimmer from "@frameworks/shared-library/components/common_shimmer";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/web/components/generic/error";
var NomineeDetails = function () {
    var _a, _b, _c, _d, _e, _f;
    var device = DeviceContext();
    var navigate = useNavigate();
    var _g = __read(useState(false), 2), showMore = _g[0], setShowMore = _g[1];
    var _h = __read(useState(undefined), 2), nomineeDetails = _h[0], setNomineeDetails = _h[1];
    var _j = __read(useState(false), 2), loader = _j[0], setLoader = _j[1];
    var _k = __read(React.useState({ isOpen: false, errMsg: null }), 2), errMsg = _k[0], setErrMsg = _k[1];
    var getnomineeDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = {};
                    return [4 /*yield*/, accountDetails.getAccTyp()];
                case 1:
                    payload = (_a.accTyp = _b.sent(),
                        _a);
                    return [4 /*yield*/, setLoader(true)];
                case 2:
                    _b.sent();
                    di.basicProfile
                        .nomineeDetailsData(payload)
                        .then(function (result) {
                        if (result && result.length > 0) {
                            setNomineeDetails(eval(JSON.parse(JSON.stringify(result))));
                            setLoader(false);
                        }
                    })
                        .catch(function (error) {
                        setLoader(false);
                        setErrMsg({ isOpen: true, errMsg: error });
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    React.useEffect(function () {
        getnomineeDetails();
    }, []);
    return (React.createElement(React.Fragment, null, loader ? (React.createElement(React.Fragment, null,
        React.createElement(Common_Shimmer, null))) : (errMsg === null || errMsg === void 0 ? void 0 : errMsg.isOpen) ? (React.createElement(React.Fragment, null,
        React.createElement(ErrorNotification, { error: errMsg === null || errMsg === void 0 ? void 0 : errMsg.errMsg, isOpen: errMsg === null || errMsg === void 0 ? void 0 : errMsg.isOpen, displayType: ErrorDisplayType.INSECTION }))) : (!(errMsg === null || errMsg === void 0 ? void 0 : errMsg.isOpen) && (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            (device === null || device === void 0 ? void 0 : device.isMobile) && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "DMSansNormal_20_400 txt-midnight-blue mt-3 ml-20", onClick: function () { return navigate(-1); } },
                    React.createElement("span", null,
                        React.createElement("i", { className: "edel-icon-arrow-left1 arrow-btn-size" })),
                    "Nomination ",
                    React.createElement("strong", null, "Details")))),
            nomineeDetails &&
                ((_c = (_b = (_a = nomineeDetails[0].DematDetails) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.Nominee_Details) === null || _c === void 0 ? void 0 : _c.length) >
                    0 ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "bg-white p-3" },
                    React.createElement("div", { className: "grid-2 mgt-md-30 mt-3" },
                        React.createElement("span", { className: "DMSanN_16_400 txt_secondary-gray" },
                            "All Nominees",
                            " ",
                            React.createElement("span", { className: "ml-1" }, "(" +
                                ((_f = (_e = (_d = nomineeDetails === null || nomineeDetails === void 0 ? void 0 : nomineeDetails[0].DematDetails) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.Nominee_Details) === null || _f === void 0 ? void 0 : _f.length) +
                                ")")),
                        React.createElement("span", { className: "DMSansMedium_12_500 Editicon-img text-right hand_cursor", onClick: function () {
                                return navigateSelf(SRRedirectionUrl[EServiceRequest.NOMINATION]);
                            } },
                            React.createElement("img", { src: Editicon }),
                            " Update Details")),
                    React.createElement("div", null,
                        showMore ? (React.createElement(React.Fragment, null,
                            React.createElement(NomineeDetailsData, { data: nomineeDetails }))) : (React.createElement(React.Fragment, null,
                            React.createElement(NomineeDetailsData, { data: nomineeDetails === null || nomineeDetails === void 0 ? void 0 : nomineeDetails.slice(0, 3) }))),
                        (nomineeDetails === null || nomineeDetails === void 0 ? void 0 : nomineeDetails.length) > 3 && (React.createElement("div", { className: "d-flex justify-content-end align-items-center showmore-content" },
                            React.createElement("button", { className: "btn DMSanM_14_500 txt-midnight-blue text-right", onClick: function () { return setShowMore(!showMore); } }, showMore ? (React.createElement("span", { className: "d-flex justify-content-center" },
                                "Show less",
                                " ",
                                React.createElement("i", { className: "edel-icon-arrow-down" }))) : (React.createElement("span", { className: "d-flex justify-content-center" },
                                "Show All",
                                " ",
                                React.createElement("i", { className: "edel-icon-arrow-down" })))))))))) : (React.createElement("div", { className: "d-flex justify-content-center mt-3 mb-3" },
                React.createElement(BasicProfileErrorMsg, { errorName: "nominees in this account" })))))))));
};
export default NomineeDetails;
